import React from 'react';
import Topbar from './Topbar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Topbar />
      <main className="flex-1 w-full">
        {children}
      </main>
      <footer className="border-t border-border bg-card mt-auto">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="font-extrabold text-base text-foreground">
                tolettu<span className="text-primary">.com</span>
              </span>
              <span className="text-muted-foreground text-sm">
                — Find your perfect rental home in India
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              © 2026 tolettu.com. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}